
export const SET_CALL_CENTER = "SET_CALL_CENTER";
export const CLEAR_STATE = "CLEAR_COMMON_STATE";
export const SET_CALL_CENTER_CUSTOMER = "SET_CALL_CENTER_CUSTOMER"
export const STORE_SEARCH_VALUE = "STORE_SEARCH_VALUE"

